module.exports = __webpack_public_path__ + "img/ic-merchantqr-step-2.46cbde0e.png";